import React from 'react'
import {Card,Image} from 'react-bootstrap';

export default function DashboardContent() {
    return (
        <div className="container-fluid">
         <div className="row">
         
         <div className="col-md-3 my-2">
         
         
         <Card style={{borderRadius:"15px"}}>
  <Card.Body>
   
    <Card.Text>
    <div className="d-flex">
<div className="icon d-flex justify-content-center align-items-center" style={{backgroundColor:"#F2F1FE"}}>
<Image src="./img/dash/1.png"></Image>
</div>

<div className="task mx-3">
<div className='my-3'>
<h6 className="task-name">New Leads</h6>
<b className="task-no">205</b>
</div>
</div>

    </div>
    </Card.Text>
  </Card.Body>
</Card>
            
         </div>


            <div className="col-md-3 my-2">
         
         
         <Card style={{borderRadius:"15px"}}>
  <Card.Body>
   
    <Card.Text>
    <div className="d-flex">
<div className="icon d-flex justify-content-center align-items-center"  style={{backgroundColor:"#C5DBFF"}}>
<Image src="./img/dash/2.png"></Image>
</div>

<div className="task mx-3">
<div className='my-3'>
<h6 className="task-name">Sales</h6>
<b className="task-no1">$4021</b>
</div>
</div>

    </div>
    </Card.Text>
  </Card.Body>
</Card>
         
         
         </div>



            <div className="col-md-3 my-2">
         
         
         <Card style={{borderRadius:"15px"}}>
  <Card.Body>
   
    <Card.Text>
    <div className="d-flex">
<div className="icon d-flex justify-content-center align-items-center" style={{backgroundColor:"#BCDDB3"}}>
<Image src="./img/dash/3.png"></Image>
</div>

<div className="task mx-3">
<div className='my-3'>
<h6 className="task-name">Orders</h6>
<b className="task-no2">80</b>
</div>
</div>

    </div>
    </Card.Text>
  </Card.Body>
</Card>
         
         
         </div>



            <div className="col-md-3 my-2">
         
         
         <Card style={{borderRadius:"15px"}}>
  <Card.Body>
   
    <Card.Text>
    <div className="d-flex">
<div className="icon d-flex justify-content-center align-items-center" style={{backgroundColor:"#FFF6E0"}}>
<Image src="./img/dash/4.png"></Image>
</div>

<div className="task mx-3">
<div className='my-3'>
<h6 className="task-name">Expense</h6>
<b className="task-no3">$1200</b>
</div>
</div>

    </div>
    </Card.Text>
  </Card.Body>
</Card>
         
         
         </div>
         
         
         
         </div>
        </div>
    )
}
